import { PersonasDict } from '@sdk/personaCollection/types/PersonasDict';
import { AuthUserType } from '@sdk/authentication/types/AuthUserType';
import { mapPersonaToPickerOption } from '@sdk/components/forms/personaPickers/GroupedPersonaPicker/groupedPersonaPicker.utils';
import { Persona } from '@sdk/personaCollection/types/Persona';
import { isUser } from '@sdk/users/utils/guards';

const isPersonaVisible = (currentUser: AuthUserType, persona: Persona) => {
  const isActive = isPersonaActive(persona);
  if (currentUser.isManager || currentUser.orgSettings.usersCanSeeUsersOutsideLocation) {
    return isActive;
  }

  return (
    isActive &&
    isUser(persona) &&
    persona.locationIds.some((id) => currentUser.locationIds.includes(id))
  );
};

const isPersonaActive = (persona: Persona) => {
  if (isUser(persona)) {
    return persona.isActive;
  }

  return persona.type === 'everyone' || !persona.archivedAt;
};

export const getMembersFieldPersonas = (currentUser: AuthUserType, personasDict: PersonasDict) => {
  return Object.values(personasDict)
    .filter((p) => isPersonaVisible(currentUser, p))
    .map(mapPersonaToPickerOption);
};
